import React from "react";
import DeviceStatusFilter from "../../Device/DeviceStatusFilter";

const WhiteListDevicePanelOptional = ({ onStatusChange }) => {
  return <DeviceStatusFilter onStatusChange={onStatusChange} />;
};

export default WhiteListDevicePanelOptional;
